import React from 'react'
import styled from 'styled-components'

const EmbedFrame = styled.iframe`
  width: 100%;
  height: calc(100vh - 180px);
  border: none;
  min-height: 400px;

  @media (max-width: 768px) {
    height: calc(100vh - 120px);
  }
`

interface MattermostEmbedProps {
  baseUrl: string
  token: string
  teamName: string
  channelName?: string
}

export const MattermostEmbed: React.FC<MattermostEmbedProps> = ({
  baseUrl,
  token,
  teamName,
  channelName,
}) => {
  // Default landing channel is #general per spec 027 plan ("landing channel is always #general")
  const channel = channelName ?? 'general'
  const path = `/${teamName}/channels/${channel}`

  const src = `${baseUrl}/login/token?token=${encodeURIComponent(token)}&redirect_to=${encodeURIComponent(path)}`

  return (
    <EmbedFrame
      src={src}
      allow="clipboard-write; clipboard-read"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
      title="Team Messaging"
    />
  )
}
